/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { StyleProp, View, ViewStyle } from "react-native";

import { upduoSecondLightestGray } from "config/UpduoColors";
import { Text } from "UpduoLibrary";
import { dashboardStyles } from "components/UserDashboardRoute/shared_components";

export default function ManagerDashboardWidget({
  title,
  style,
  children,
  tag,
}: React.PropsWithChildren<{
  title: string;
  style?: StyleProp<ViewStyle>;
  tag?: React.ReactNode;
}>) {
  return (
    <View
      style={[
        style,
        {
          borderColor: upduoSecondLightestGray,
          borderWidth: 1,
          borderStyle: "solid",
          borderRadius: 12,
          flexDirection: "column",
          padding: 20,
          zIndex: 5,
        },
      ]}
    >
      <View
        style={{
          flexDirection: "row",
          justifyContent: tag ? "space-between" : "flex-start",
          alignItems: "flex-start",
        }}
      >
        <Text
          style={[
            dashboardStyles.widgetTitle,
            {
              marginBottom: 10,
            },
          ]}
        >
          {title}
        </Text>
        {tag}
      </View>
      {children}
    </View>
  );
}
